
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"24","height":"24"}},[_c('path',{attrs:{"fill":"#D9D9D9","d":"M0 0h24v24H0z"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"fill":"currentColor","d":"M9 20v-6c-1.383 0-2.563-.488-3.537-1.463C4.487 11.563 4 10.383 4 9s.487-2.563 1.463-3.537C6.437 4.487 7.617 4 9 4h9v2h-2v14h-2V6h-3v14H9z"}})])])
          )
        }
      }
    